import { render, staticRenderFns } from "./SingleReferral.vue?vue&type=template&id=67ad5dba&scoped=true&"
import script from "./SingleReferral.vue?vue&type=script&lang=js&"
export * from "./SingleReferral.vue?vue&type=script&lang=js&"
import style0 from "./SingleReferral.vue?vue&type=style&index=0&id=67ad5dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad5dba",
  null
  
)

export default component.exports